<template>
  <div class="gx-floatpts" :class="{ 'gx-floatpts--fixed': fixed }">
    <div
      v-for="(p, i) in pts"
      :key="i"
      class="gx-floatpts__dot"
      :style="{
        left: p.left,
        bottom: 0,
        width: p.sz + 'px',
        height: p.sz + 'px',
        background: p.col,
        boxShadow: `0 0 6px ${p.col}`,
        animation: `gx-floatUp var(--gx-member-float-duration, ${p.dur}s) ${p.del}s infinite var(--gx-member-ease, ease-in)`
      }"
    ></div>
  </div>
</template>

<script>
export default {
  name: 'FloatPts',
  props: {
    count: { type: Number, default: 10 },
    fixed: { type: Boolean, default: false },
    colors: {
      type: Array,
      default: () => ['#D4A946', '#00C8F5', '#7C3AED']
    }
  },
  data() {
    const colors = this.colors.length ? this.colors : ['#D4A946']
    return {
      pts: Array.from({ length: this.count }, (_, i) => ({
        left: `${8 + Math.random() * 84}%`,
        del: `${Math.random() * 12}s`,
        dur: `${4 + Math.random() * 5}s`,
        sz: 1 + Math.random() * 2.5,
        col: colors[i % colors.length]
      }))
    }
  }
}
</script>

<style scoped>
.gx-floatpts {
  position: absolute;
  inset: 0;
  pointer-events: none;
  overflow: hidden;
  z-index: 1;
}
.gx-floatpts--fixed {
  position: fixed;
}
.gx-floatpts__dot {
  position: absolute;
  border-radius: 50%;
}
</style>
